import React from 'react';
import { Spinner } from '@indeed/ifl-components';
import './FullScreenSpinner.scss';
const FullScreenSpinner = ({ title, description }) => (React.createElement("div", { className: "FullScreenSpinner", role: "status" },
    React.createElement(Spinner, { inverse: true, title: "", sx: { width: '5rem', height: '5rem' }, ...(title
            ? {
                'aria-hidden': true
            }
            : { 'aria-label': '読み込み中' }) }),
    title && React.createElement("div", { className: "FullScreenSpinner-title" }, title),
    description && React.createElement("div", { className: "FullScreenSpinner-description" }, description)));
export default FullScreenSpinner;
